module.exports = __webpack_public_path__ + "img/paso_2.a96e4fcf.png";